var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFollowup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 33,
    viewBox: "0 0 39 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0263 13.5513L32.894 8.41911L38.0263 3.28687",
    stroke: "white",
    strokeWidth: 1.71188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0961 13.5513L27.9639 8.41911L33.0961 3.28687",
    stroke: "white",
    strokeWidth: 1.71188,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4602 19.7209C20.9984 19.7209 24.6772 15.3062 24.6772 9.86045C24.6772 4.41467 20.9984 0 16.4602 0C11.9221 0 8.24316 4.41467 8.24316 9.86045C8.24316 15.3062 11.9221 19.7209 16.4602 19.7209Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5655 28.1023C31.0865 25.1442 28.2927 22.6791 24.6772 21.2C23.6911 20.8713 22.5407 20.8713 21.719 21.3644C20.0756 22.3504 18.4322 22.8434 16.4601 22.8434C14.488 22.8434 12.8446 22.3504 11.2012 21.3644C10.3795 21.0357 9.22912 20.8713 8.24308 21.3644C4.62758 22.8434 1.83378 25.3085 0.354716 28.2667C-0.79567 30.4031 1.01208 32.8682 3.47719 32.8682H29.443C31.9082 32.8682 33.7159 30.4031 32.5655 28.1023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowup);
export default __webpack_public_path__ + "static/media/followup.cbe4dd8c1bf6fb2a1cb1b74ed7f02abb.svg";
export { ForwardRef as ReactComponent };